import { getImageUrl } from '../utils/imageUrl';

export type AirlineInfo = {
  id: number;
  name: string;
  logo: string;
  code?: string | null;
};

type Props = {
  airline: AirlineInfo | null | undefined;
  variant?: 'default' | 'compact';
  tone?: 'light' | 'hero';
  className?: string;
};

export default function AirlineBadge({
  airline,
  variant = 'default',
  tone = 'light',
  className = '',
}: Props) {
  if (!airline?.name) return null;

  const logoSize = variant === 'compact' ? 'h-7 w-7' : 'h-9 w-9';
  const shell =
    tone === 'hero'
      ? 'border border-white/35 bg-black/25 backdrop-blur-sm shadow-sm'
      : 'border border-gray-200 bg-white/95 shadow-sm';
  const nameCls =
    tone === 'hero'
      ? 'text-sm font-medium text-white truncate max-w-[12rem]'
      : 'text-sm font-medium text-gray-800 truncate max-w-[10rem]';
  const codeCls =
    tone === 'hero'
      ? 'text-xs text-white/80 font-mono shrink-0'
      : 'text-xs text-gray-500 font-mono shrink-0';

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-lg px-2 py-1.5 ${shell} ${className}`}
      title={airline.code ? `${airline.name} (${airline.code})` : airline.name}
    >
      {airline.logo ? (
        <img
          src={getImageUrl(airline.logo)}
          alt=""
          className={`${logoSize} object-contain shrink-0`}
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      ) : null}
      <span className={nameCls}>{airline.name}</span>
      {airline.code ? <span className={codeCls}>{airline.code}</span> : null}
    </div>
  );
}
